<script module lang="ts">
  let counter = 0;
</script>

<script lang="ts">
  import type { Interval } from "../type";
  import { type FeatureTrackingReference, featureTrackingReferenceAttributes } from "../../tracking";
  import { initToggles, isActive } from "../../../toggle/Toggle";

  interface Props {
    range?: Interval;
    unit?: string;
    availableRange?: Required<Interval>;
    featureTrackingReference?: FeatureTrackingReference;
    isValid: boolean;
  }

  let { unit, range = $bindable(), availableRange, featureTrackingReference, isValid }: Props = $props();

  initToggles();
  const preventInvalidSelections = isActive("HEUREKA_2208_PREVENT_SUBMISSION_OF_INVALID_SELECTIONS");

  const minInputId = `hc_minMax__min${counter}`;
  const maxInputId = `hc_minMax__max${counter++}`;

  const defaultValueMin = range?.from;
  const defaultValueMax = range?.to;

  let labelSuffix = (unit && ` (${unit})`) || "";
  /*                                                                   */
  /*                                                                                                  */
  function onUpdateMinValueOc(event: Event) {
    const target = event.target as HTMLElement & { value?: string };
    const from = Number(target.value);
    if (range) {
      range.from = target.value === "" || isNaN(from) ? undefined : from;
    }
  }

  function onUpdateMaxValueOc(event: Event) {
    const target = event.target as HTMLElement & { value?: string };
    const to = Number(target.value);
    if (range) {
      range.to = target.value === "" || isNaN(to) ? undefined : to;
    }
  }
</script>

<div class="hc_minMax hc_minMax--oc">
  <oc-text-field-v1
    id={minInputId}
    maxlength="5"
    type="number"
    inputmode="numeric"
    placeholder={availableRange?.from?.toFixed() || ""}
    value={range?.from ? String(range.from) : ""}
    variant={isValid ? "default" : "error"}
    without-optional-label
    data-default-value={defaultValueMin ? defaultValueMin : ""}
    data-ts-feature-filter-method="interval"
    oninput={preventInvalidSelections ? onUpdateMinValueOc : undefined}
    onchange={preventInvalidSelections ? undefined : onUpdateMinValueOc}
    {...featureTrackingReferenceAttributes(featureTrackingReference)}>Von{labelSuffix}</oc-text-field-v1
  >
  <oc-text-field-v1
    id={maxInputId}
    maxlength="5"
    type="number"
    inputmode="numeric"
    placeholder={availableRange?.to?.toFixed() || ""}
    value={range?.to ? String(range.to) : ""}
    variant={isValid ? "default" : "error"}
    without-optional-label
    data-default-value={defaultValueMax ? defaultValueMax : ""}
    data-ts-feature-filter-method="interval"
    oninput={preventInvalidSelections ? onUpdateMaxValueOc : undefined}
    onchange={preventInvalidSelections ? undefined : onUpdateMaxValueOc}
    {...featureTrackingReferenceAttributes(featureTrackingReference)}>Bis{labelSuffix}</oc-text-field-v1
  >
</div>

<style lang="scss">
  .hc_minMax {
    margin: 0;
    width: 100%;
    display: flex;
    gap: var(--oc-semantic-spacing-50);
    /*                                      */
    padding-top: var(--oc-semantic-spacing-50);

    > * {
      flex: 1;
      /*                                                      */
      min-width: 0;
      margin: 0;
    }
  }

  .hc_minMax--oc {
    /*                              */
    padding-left: var(--oc-semantic-spacing-12);
    padding-right: var(--oc-semantic-spacing-12);
  }
</style>
